// extracted by mini-css-extract-plugin
export default {"sib-header-overlay":"ytLzRyQRz0dfule9bdlB","sib-header-overlay-toggled":"goMQXlBVbx64oLdMRrA0"};